/**
 * Created by Mikhail Menshenin on 25.04.2024
 */

const RiddlesLevelMasteryRewardView = cc.Node.extend({
    ctor: function (rewardsList, options) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.options = options || {};

        const icon = this.icon = rewardsList.listRewards().length > 1 ? this.createPrize(rewardsList) : this.createReward(rewardsList);
        icon.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        this.addChild(icon);
        cleverapps.UI.wrap(this);
    },

    createPrize: function (rewards) {
        const prize = new cleverapps.Spine(bundles.prize.jsons.prize_json);
        prize.setAnimation(0, "idle", true);

        cleverapps.UI.onClick(prize, () => {
            const tooltip = Prefab.instantiate(bundles.levelmastery.jsons.levelmastery_tooltip_prefab_json, { rewards });
            tooltip.show(prize);
        });

        return prize;
    },

    createReward: function (rewardsList) {
        const styles = cleverapps.styles.RiddlesLevelMasteryRewardView;

        const icon = new RewardsListComponent(rewardsList, {
            font: this.options.font || cleverapps.styles.FONTS.RIDDLES_LEVELMASTERY_REWARD_TEXT,
            textPosition: styles.text,
            hideTextForSingleReward: true,
            noShowControls: true,
            help: true
        });

        if (styles.ribbon !== false) {
            const ribbonBack = this.ribbonBack = cleverapps.UI.createScale9Sprite(bundles.levelmastery.frames.ribbon_back);
            ribbonBack.setContentSize(Math.max(styles.ribbon.minWidth, icon.getContentSize().width + 2 * styles.ribbon.padding), styles.ribbon.height);
            ribbonBack.setAlignment(styles.ribbon);
            this.addChild(ribbonBack, -1);

            const ribbon = this.ribbon = cleverapps.UI.createScale9Sprite(bundles.levelmastery.frames.ribbon_front);
            ribbon.setContentSize(Math.max(styles.ribbon.minWidth, icon.getContentSize().width + 2 * styles.ribbon.padding), styles.ribbon.height);
            ribbon.setAlignment(styles.ribbon);
            this.addChild(ribbon, 1);

            const reward = icon.getTargets()[0];
            reward.text.removeFromParent();

            // eslint-disable-next-line no-restricted-syntax
            const text = cleverapps.UI.generateTTFText(rewardsList.listRewards()[0].getText(RewardType.DEFAULT_PREFIX), this.options.font || cleverapps.styles.FONTS.RIDDLES_LEVELMASTERY_REWARD_TEXT);
            text.setAlignment(styles.text);
            ribbon.addChild(text);
        }

        return icon;
    },

    takeOffAnimation: function () {
        this.ribbonBack.runAction(
            new cc.MoveBy(0.1, 0, -15)
        );

        this.ribbon.runAction(
            new cc.MoveBy(0.1, 0, -15)
        );

        this.icon.runAction(
            new cc.MoveBy(0.1, 0, 15)
        );
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RIDDLES_LEVELMASTERY_REWARD_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        size: 40
    }
});

cleverapps.styles.RiddlesLevelMasteryRewardView = {
    ribbon: false,

    text: {
        x: { align: "right", dx: 20 },
        y: { align: "bottom" }
    }
};
